import '../../styles.scoped.css'
import {useState} from 'react'
import {Typography, TextField, IconButton, InputAdornment} from '@mui/material'
import {Visibility, VisibilityOff} from '@mui/icons-material'
import {ENVIRONMENTS} from '../../../AdminOrganizationDetails/components'
import {API_VERSIONS} from '../../helpers'
import {FormSelect} from '../Branches'
import FieldLabel from '../FieldLabel'

export default ({form}) => {
    const errors = form.formState.errors
    const [showSecret, setShowSecret] = useState(false)

    return (
        <>
            <Typography variant="h6" color="text.primary">
                EVV Credentials
            </Typography>
            <Typography className="panel-subtitle" variant="body2" color="text.secondary">
                One set of HHAeXchange credentials covers the whole organization, every enrolled branch submits visits under these. They're stored
                encrypted and never shown again after saving.
            </Typography>
            <div className="field">
                <FieldLabel>Client ID</FieldLabel>
                <TextField
                    placeholder="Client ID issued by HHAeXchange"
                    fullWidth
                    {...form.register('client_id', {deps: ['client_secret']})}
                    error={!!errors?.client_id}
                    helperText={errors?.client_id?.message}
                />
            </div>
            <div className="field">
                <FieldLabel>Client Secret</FieldLabel>
                <TextField
                    placeholder="Client secret issued by HHAeXchange"
                    fullWidth
                    type={showSecret ? 'text' : 'password'}
                    {...form.register('client_secret', {deps: ['client_id']})}
                    error={!!errors?.client_secret}
                    helperText={errors?.client_secret?.message}
                    slotProps={{
                        input: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton aria-label={showSecret ? 'Hide secret' : 'Show secret'} onClick={() => setShowSecret(prev => !prev)}>
                                        {showSecret ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        },
                    }}
                />
            </div>
            <div className="form">
                <div className="form-left field">
                    <FieldLabel>Environment</FieldLabel>
                    <FormSelect form={form} name="base_url" options={ENVIRONMENTS} empty="Select environment" />
                </div>
                <div className="form-right field">
                    <FieldLabel>API Version</FieldLabel>
                    <FormSelect form={form} name="api_version" options={API_VERSIONS} empty="Select API version" />
                </div>
            </div>
            <Typography variant="body2" color="text.secondary">
                These are checked against HHAeXchange before they're saved. Leave them blank to set them later from the organization's EVV tab.
            </Typography>
        </>
    )
}
